(function () {
  const AUTOPLAY_DELAY = 400000;

  function init() {
    const section = document.querySelector('.clay-about-app');
    const el      = document.querySelector('.clay-about-app__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    const swiper = new Swiper(el, {
      centeredSlides: true,
      initialSlide: 0,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      pagination: {
        el: '.clay-about-app__bullets',
        clickable: true,
        bulletClass: 'clay-about-app__bullet',
        bulletActiveClass: 'clay-about-app__bullet--active',
        renderBullet: (index, className) =>
          `<button type="button" aria-label="Slide ${index + 1}" class="${className}"></button>`,
      },
      autoplay: {
        delay: AUTOPLAY_DELAY,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      on: {
        activeIndexChange(s) {
          // Play active, pause previous
          const active = s.slides[s.activeIndex];
          const prev   = s.slides[s.previousIndex];
          if (active) { const v = active.querySelector('video'); if (v && v.paused) v.play(); }
          if (prev)   { const v = prev.querySelector('video');   if (v && !v.paused) v.pause(); }
        },
      },
    });

    // Pause when out of viewport
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) swiper.autoplay.resume();
      else swiper.autoplay.pause();
    }).observe(section);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else setTimeout(init, 0);
})();
